module.exports = __webpack_public_path__ + "img/logo_color.72a413bf.png";